<template>
  <v-card :loading="loading" :disabled="loading">
    <v-toolbar flat>
      <v-icon left color="accent">mdi-golf-cart</v-icon>
      <v-toolbar-title>Putters</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn outlined @click="openForm()">
        <v-icon>mdi-plus</v-icon>Add Single Putter
      </v-btn>
    </v-toolbar>
    
    <PrescriptionItems
      :headers="headers"
      :items="items"
      :isModifiable="isModifiable"
      @update="update()"
      @edit="(item) => openForm(item)"
    />
    
    <putter-form
      ref="putterForm"
      :prescriptionId="prescriptionId"
      :currency="prescription.currency.currency"
      :dominantHand="dominantHand"
      :catalogId="this.catalogId"
      @update="update()"
    ></putter-form>
  </v-card>
</template>

<script>
import PrescriptionItems from './PrescriptionItems.vue';
import PutterForm from "./PutterForm";

export default {
  components: {
    PutterForm,
    PrescriptionItems
},
  props: [
    "putters",
    "prescriptionId",
    "dominantHand",
    "catalogId",
    "prescription"
  ],
  data: function() {
    return {
      items: this.putters,
      itemToEdit: null,
      formEdit: false,
      headers: [
        { text: "Quote", value: "quote", sortable: false },
        { text: "Quantity", value: "quantity" },
        { text: "SST Pure", value: "sst", sortable: false },
        { text: "Stamping", value: "stamping", sortable: false },
        { text: "Paintfill", value: "paintfill", sortable: false },
        { text: "Head", value: "head" },
        { text: "Shaft", value: "shaft" },
        { text: "Grip", value: "grip" },
        { text: "Actions", value: "actions"},
      ],
      loading: false
    };
  },
  computed : {
    isModifiable () {
      return this.prescription.isModifiable
    }
  },
  methods: {
    getList() {
      this.loading = true
      this.$store
        .dispatch("prescriptionPutter/get", {
          id: this.prescriptionId
        })
        .then(datas => (this.items = datas))
        .finally(() => {this.loading = false});
    },
    update() {
      this.getList();
      this.$emit("update");
    },

    openForm(item) {
      this.$refs.putterForm.open(item)
    }
  }
};
</script>

<style></style>
